// extracted by mini-css-extract-plugin
export default {"checkout":"checkout_checkout__ztbQZ"};